/**
 * Frequency cap for the post-download "email me this design" modal: it opens
 * on its own at most once per six hours. Someone generating a run of designs
 * would otherwise get it after every single download.
 *
 * One key for the whole browser, not one per token like proUpsellStorage:
 * this is about how often this browser gets interrupted, and the address it
 * prefills from (emailStorage) is browser-wide too. While the cap holds,
 * pages offer an "Email me this design" button under the downloads instead,
 * so the modal is still one click away.
 */
const LAST_SHOWN_KEY = "email_prompt_last_shown";
const COOLDOWN_MS = 6 * 60 * 60 * 1000;

export function hasShownEmailPromptRecently(now: number = Date.now()): boolean {
  const lastShown = Number(localStorage.getItem(LAST_SHOWN_KEY));
  // A missing or unparseable value is NaN/0, i.e. "never shown". A timestamp
  // in the future (clock moved backwards) is treated as stale rather than
  // suppressing the modal indefinitely.
  if (!lastShown || lastShown > now) return false;
  return now - lastShown < COOLDOWN_MS;
}

export function markEmailPromptShown(now: number = Date.now()): void {
  localStorage.setItem(LAST_SHOWN_KEY, String(now));
}
